// @flow
import { handleResponseOld, makeGet } from './helpers';

type FetchCurrencyConversionsParams = {
    authToken?: string,
    deployment: string,
};

const transform = (response = {}) => {
    return {
        data: {
            conversions: response.payload,
        },
        error: response.error,
    };
};

export default {
    fetchCurrencyConversions: ({ authToken, deployment }: FetchCurrencyConversionsParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makeGet({ authToken, deployment, path: '<CURRENCY-API>' });
            request.end((err, response) =>
                handleResponseOld({
                    err,
                    reject,
                    resolve,
                    response,
                    transform,
                }),
            );
        }),
};
